import React, { useCallback, useEffect, useState } from 'react';
import "./KeytermPopover.css";
// NORTON DESIGN SYSTEM
import { Button, Popover } from '@wwnds/react';


const KeytermPopover = ({ title, description, annotationPaneRef }) => {

  const [isOpen, setIsOpen] = useState(false);
  const [ref, setRef] = useState();
  const [placement, setPlacement] = useState("bottom")

  const handleScroll = useCallback(() => {
    if (ref && annotationPaneRef.current) {
      const popoverPos = ref.getBoundingClientRect().top
      const containerTop = annotationPaneRef.current.getBoundingClientRect().top
      const containerBottom = annotationPaneRef.current.getBoundingClientRect().bottom
      const distanceTop = popoverPos - containerTop
      const distanceBottom = containerBottom - popoverPos
      const placement = distanceTop < distanceBottom || parseFloat(distanceTop) < 50 ? "bottom" : "top"
      if (popoverPos > containerBottom || popoverPos < containerTop) {
        setIsOpen(false)
      }
      // console.log(placement)
      setPlacement(placement)
    }
  }, [ref, setPlacement, annotationPaneRef])

  useEffect(() => {
    if (isOpen) {
      const scrollingElement = document.querySelector(".annotation-pane")
      // console.log(scrollingElement)
      scrollingElement.addEventListener("scroll", handleScroll)
      return () => {
        scrollingElement.removeEventListener('scroll', handleScroll);
      };
    }
  }, [handleScroll, isOpen])

  return (
    <>
      <Button variant="ghost" style={{ padding: "0px" }} ref={setRef} textClass="keyterm-popover-btn-txt"
      >
        <span className="keyterm-popover-btn-txt" dangerouslySetInnerHTML={{__html: title}}></span>
      </Button>
      <Popover
        title={title}
        hideTitle={true}
        hideCloseButton={true}
        placement={placement}
        reference={ref}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        onRequestOpen={() => setIsOpen(true)}
      >
        <span className="popover-keyterm" dangerouslySetInnerHTML={{ __html: title }}></span>
        <span>: </span>
        {/* {description} */}
        <span dangerouslySetInnerHTML={{ __html: description }}></span>
        <div className="popover-close-btn-container">
          <Button onClick={() => setIsOpen(false)} variant="ghost" textClass="popover-close-btn-txt">Close</Button>
        </div>
      </Popover>
    </>
  );
}

export default KeytermPopover